import React, { useEffect, useState } from "react";
import { TextField, Button, Box } from "@mui/material";
import { useResourcePermissions } from "../../../common/hooks/resource-permissions";
import MODULES from "../../../constants/modules";
import {
  editTemplateHeaderOrFooter,
  getTemplateHeaderOrFooter,
} from "../../../api/email-letter-templates";
import { AlertComponent } from "../../../common/components";
import UnsubscribedUsersList from "../unsubscribed-users-list";

const OptOutTab: React.FC<{
  setSelectedUserId: (id: number | null) => void;
  setSelectedUserType: (type: string) => void;
  setSelectedUserName: (name: string) => void;
  setViewOpen: (isOpen: boolean) => void;
  setCrumbMappingOption: (crumbs: any[]) => void;
  setIndexValue: (index: number) => void;
}> = ({
  setSelectedUserId,
  setSelectedUserType,
  setSelectedUserName,
  setViewOpen,
  setCrumbMappingOption,
  setIndexValue
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [optOutLink, setOptOutLink] = useState("");
  const [defaultContent, setDefaultContent] = React.useState<any>("");
  const [alertMessage, setAlertMessage] = React.useState<any>({
    open: false,
    message: "",
  });
  const [optOutContent, setOptOutContent] = useState<string>("");

  const { canRead, canWrite, canDelete } = useResourcePermissions(
    MODULES.EMAIL_TEMPLATES
  );

  const getHeaderContent = async () => {
    try {
      const res = await getTemplateHeaderOrFooter("OptOutText");
      const data = res?.data?.data;
      const headerData = data?.length
        ? data?.filter((item: any) => item.key === "OptOutText")?.[0]
        : null;
      if (headerData) {
        setOptOutContent(headerData.value);
        setDefaultContent(headerData.value);
      }
    } catch (error: any) {
      console.error("Error fetching header content:", error);
    }
  };

  const editHeaderContent = async () => {
    try {
      const res = await editTemplateHeaderOrFooter("OptOutText", {
        value: optOutContent,
      });
      setIsEditing(false);
      getHeaderContent();
      setAlertMessage({
        open: true,
        message: `Opt Out text updated successfully.`,
        type: "success",
      });
    } catch (error: any) {
      setAlertMessage({
        open: true,
        message:
          error?.response?.data?.message || "Failed to save Opt Out text.",
        type: "error",
      });
      console.error("Error editing header content:", error);
    }
  };

  useEffect(() => {
    getHeaderContent();
  }, []);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  return (
    <div className="opt-out-tab-wrapper">
      <div className="opt-out-tab-content">
        {isEditing ? (
          <>
            <p>=== REMOVE FROM MAILING LIST ===</p>
            <TextField
              fullWidth
              multiline
              value={optOutContent}
              className="opt-out-content-input"
              onChange={(e) => setOptOutContent(e.target.value)}
            />

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Button
                variant="outlined"
                onClick={() => {
                  setIsEditing(false);
                  setOptOutContent(defaultContent);
                }}
                sx={{ mt: 2 }}
                className="edit-opt-out-button-cancel"
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                onClick={editHeaderContent}
                sx={{ mt: 2 }}
                className="edit-opt-out-button"
              >
                Save
              </Button>
            </Box>
          </>
        ) : (
          <>
            <div className="content-text">
              <p>=== REMOVE FROM MAILING LIST ===</p>
              {optOutContent}
            </div>
            <Button
              variant="outlined"
              onClick={handleEditClick}
              sx={{ mt: 2 }}
              className="edit-opt-out-button"
            >
              Edit
            </Button>
          </>
        )}
      </div>
      <div className="opt-out-tab-link-tab-wrapper">
        <a
          href="/opt-out"
          target="_blank"
          rel="noopener noreferrer"
          className="opt-out-link"
        >
          [Opt-Out Link will automatically appear here]
        </a>
      </div>
       <UnsubscribedUsersList
        setSelectedUserId={setSelectedUserId}
        setSelectedUserType={setSelectedUserType}
        setSelectedUserName={setSelectedUserName}
        setViewOpen={setViewOpen}
        setCrumbMappingOption={setCrumbMappingOption}
        setIndexValue={setIndexValue} 
      />



      {alertMessage?.open && (
        <AlertComponent
          message={alertMessage?.message}
          type={alertMessage?.type || "error"}
          open={alertMessage?.open}
          onClose={() => {
            setAlertMessage({ open: false });
          }}
        />
      )}
    </div>
  );
};

export default OptOutTab;
